import React, { useState, useEffect, useContext } from "react";
import { DataGrid, GridToolbarQuickFilter } from "@mui/x-data-grid";
import { Link, useNavigate, useLocation } from "react-router-dom";
import { useMutation, useManualQuery, ClientContext } from "graphql-hooks";

import {
  Container,
  Card,
  CardContent,
  Grid,
  Typography,
  Divider,
  TextField,
  Radio,
  Checkbox,
  Tooltip,
  Button,
  Dialog,
  DialogTitle,
  DialogActions,
  DialogContent,
  DialogContentText,
  makeStyles,
} from "@material-ui/core";
import Box from "@mui/material/Box";
import update from "immutability-helper";
import styled from "styled-components";
import { REFRESH_TOKEN_MUTATION, STAFF_MODULE_ACCESS_QUERY } from "../../graphQL/user_qry";

import {
  EDIT_TENANT_MUTATION,
  GET_TENANT_DATA_BY_USER,
  UPDATE_TENANT_STATES,
} from "../../graphQL/tenant_qry";

import penImg from "../../assets/icons/pen.png";
import trashImg from "../../assets/icons/trash.png";
import AlertDialog from "../../components/AlertDialog.js";
import ManageStateInputsDialog from "../../components/ManageStateInputsDialog.js";

import { project_url } from "../../constants/Data";

import Header from "./Header.js";

const StyledTooltip = styled(props => (
  <Tooltip
    classes={{ popper: props.className }}
    {...props}
    PopperProps={{
      popperOptions: {
        modifiers: {
          flip: { enabled: false },
          offset: {
            offset: "0px, -50px, 20px, -25px",
          },
        },
      },
    }}
  />
))`
  & .MuiTooltip-tooltip {
    display: flex;
    background: #757575;
    color: #fff;
    border-radius: 4px;
    font-size: 10px;
    font-weight: 500;
  }
`;

const useStyles = makeStyles(theme => ({
  root: {
    marginRight: "8rem",
    textAlign: "center",
    padding: theme.spacing(2),
    paddingLeft: 0,
    paddingRight: 0,
    width: "1400px",
    paddingTop: "7.5rem",
    //  minWidth: "500px",
  },
  container: {
    padding: theme.spacing(4),
    //  paddingTop:theme.spacing(2),
    marginTop: "1rem",
    marginBottom: "5rem",
    overflow: "hidden",
    clear: "both",
    borderRadius: "8px",
    backgroundColor: "#ffffff",
  },

  outlinedButtonStyle: {
    borderRadius: 8,
    width: "110px",
    padding: 0,
    height: "48px",
    textTransform: "none",
  },
  buttonStyle: {
    borderRadius: 4,
    width: "100px",
    padding: 0,
    color: "#fff",
    height: "34px",
    backgroundColor: "#0D47A1",
    textTransform: "none",
    // "&:active": {
    //   backgroundColor: "#765285",
    // },
    "&:hover": {
      backgroundColor: "#1E88E5",
    },
  },
  dataGridStyle: {
    // "&.MuiDataGrid-scrollbar MuiDataGrid-scrollbar--horizontal css-1rtad1": {
    //   position: "relative",
    //   display: "block",
    // },
    "&.MuiDataGrid-root": {
      //paddingTop:10,
      //  minWidth: 980,
      //  width:"100%"
      //  overflowX: 'scroll'
    },

    "& .MuiDataGrid-cell:focus-within": {
      outline: "none !important",
    },
    "& .MuiDataGrid-columnHeader:last-child .MuiDataGrid-columnSeparator": {
      display: "none",
    },
    "& .MuiDataGrid-columnHeaderTitle": {
      fontWeight: 700,
      fontSize: 12,
    },
  },
}));

function ManageStates() {
  const [loadData, setLoadData] = useState(false);
  const [loadContent, setLoadContent] = useState(false);

  const [pageSize, setPageSize] = useState(20);
  const client = useContext(ClientContext);
  const navigate = useNavigate();
  const [pathname] = useState(window.location.pathname);

  const [statesData, setStatesData] = useState([]);
  const [statesUpdatedData, setStatesUpdatedData] = useState([]);
  const [extraErrMsg, setExtraErrMsg] = useState("");
  const [alertDeleteMsg, setAlertDeleteMsg] = useState([]);
  const [manageStateInputsDialogMsg, setManageStateInputsDialogMsg] = useState([]);
  const [alertDoneMsg, setAlertDoneMsg] = useState([]);
  const [lastUpdate, setLastUpdate] = useState(["10/27/2024"]);

  const [checkStaffModuleAccess] = useManualQuery(STAFF_MODULE_ACCESS_QUERY, {
    fetchPolicy: "network-only",
  });

  let tenantUserId = 0;
  if(localStorage.getItem("tenantUserId"))
    tenantUserId = localStorage.getItem("tenantUserId");

  let isTenantAdmin = false;  
  if(localStorage.getItem("isTenantAdmin"))
    isTenantAdmin = JSON.parse(localStorage.getItem("isTenantAdmin"));

  let clientId = 0;
  if (localStorage.getItem("clientId")) 
    clientId = localStorage.getItem("clientId");

  const [access, setAccess] = useState(true);
  const [viewAccess, setViewAccess] = useState(false);
  const [addAccess, setAddAccess] = useState(false);
  const [editAccess, setEditAccess] = useState(false);
  const [deleteAccess, setDeleteAccess] = useState(false);

  const checkAccess = async () => {
    //check if staff has access to module
    
    const {
            loading: accessDataLoading,
            error: accessDataError,
            data: accessData,
          } = await checkStaffModuleAccess({
            variables: {
              tenantUserId: parseInt(tenantUserId),  
              clientId: parseInt(clientId), 
              moduleName: "General Settings",
              modulepageName: "Manage States"     
            },
          });

    if (!accessDataLoading && accessData && accessData.staffModuleAccess) {      
      setAccess(accessData.staffModuleAccess.access);
      let commonActions = accessData.staffModuleAccess.commonActions.split('|');
      if(commonActions.find(a => a == "View"))
        setViewAccess(true)
      if(commonActions.find(a => a == "Add"))
        setAddAccess(true)
      if(commonActions.find(a => a == "Edit"))
        setEditAccess(true)
      if(commonActions.find(a => a == "Delete"))
        setDeleteAccess(true)

      
    }

    if (  accessDataError &&
          accessDataError.graphQLErrors &&
          accessDataError.graphQLErrors[0].message === "Signature has expired"
       ) {
            navigate(`${project_url}/signin`);
          }
  }

  useEffect(() => {
    window.scrollTo(0, 0);
    (() => checkAccess())();
  }, []);

  const formatter = new Intl.DateTimeFormat("en-us", {
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
  });

  const dayFormat = day => {
    const dayDate = new Date(day);
    const dayFormat = formatter.formatToParts(dayDate);
    const newFormat =
      dayFormat.find(a => a.type == "month").value +
      "/" +
      dayFormat.find(a => a.type == "day").value +
      "/" +
      dayFormat.find(a => a.type == "year").value;
    return newFormat;
  };

  const [refreshToken] = useMutation(REFRESH_TOKEN_MUTATION, {
    onError: err => {
      console.log(err);
    },
  });
  useEffect(() => {
    if (localStorage.getItem("refreshToken")) {
      onRefreshToken();
    } else window.location.href = `${project_url}/signin/?next=${pathname}`;
  }, []);
  const onRefreshToken = async () => {
    const { data: refreshData, error: refreshError } = await refreshToken({
      variables: { refreshToken: localStorage.getItem("refreshToken") },
    });
    if (refreshError) {
      if (
        refreshError.graphQLErrors[0].message ===
        "You do not have permission to perform this action"
      )
        window.location.href = `${project_url}/signin/?next=${pathname}`;
      if (refreshError.graphQLErrors[0].message === "Signature has expired")
        window.location.href = `${project_url}/signin/?next=${pathname}`;
    }
    if (refreshData && refreshData.refreshToken) {
      localStorage.setItem("token", refreshData.refreshToken.token);
      localStorage.setItem("refreshToken", refreshData.refreshToken.refreshToken);
      client.setHeader("Authorization", `JWT ${refreshData.refreshToken.token}`);
      setLoadContent(true);
    }
  };
  const [getUserTenantData] = useManualQuery(GET_TENANT_DATA_BY_USER, {
    fetchPolicy: "network-only",
  });

  const [editTenant] = useMutation(EDIT_TENANT_MUTATION, {
    awaitRefetchQueries: true,
  });

  const [updateTenantStatesMutation] = useMutation(UPDATE_TENANT_STATES);

  const getTenant = async () => {
    // Get tenant information
    const {
      loading: tenantDataLoading,
      error: tenantDataError,
      data: tenantData,
    } = await getUserTenantData();

    if (!tenantDataLoading && tenantData && tenantData.getUserTenantData) {
      let states = [];
      let allData = tenantData.getUserTenantData.states.split("updateDate");
      if (allData.length > 2) {
        let userUpdateDate = "";
        JSON.parse(tenantData.getUserTenantData.states).map((item, index) => {
          states.push({
            index: index,
            stateName: item.fields.stateName,
            stateCode: item.fields.stateCode,
            desc: item.fields.desc,
          });
          userUpdateDate = item.fields.updateDate;
        });
        setLastUpdate(dayFormat(userUpdateDate));
      } else {
        JSON.parse(allData[0]).map((item, index) => {
          states.push({
            index: index,
            stateName: item.stateName,
            stateCode: item.stateCode,
            desc: item.desc,
          });
        });
        setLastUpdate(dayFormat(allData[1]));
      }
      // console.log(
      //   "states_item__",
      //   tenantData.getUserTenantData.states,
      //   states
      // );
      setStatesData(states);
      setStatesUpdatedData(states);

      setLoadData(true);
    }
    if (
      tenantDataError &&
      tenantDataError.graphQLErrors &&
      tenantDataError.graphQLErrors[0].message === "Signature has expired"
    ) {
      navigate(`${project_url}/signin`);
    }
  };
  const rows = statesUpdatedData.map(state => ({
    index: state.index,
    name: state.stateName,
    code: state.stateCode,
    desc: state.desc,
    editAccess : editAccess,
    deleteAccess: deleteAccess,
  }));
  useEffect(() => {
    window.scrollTo(0, 0);
    (() => getTenant())();
  }, []);

  const updateState = (values, index) => {
    const findStateIndex = statesUpdatedData.findIndex(item => item.index === index);

    if (findStateIndex !== -1) {
      statesUpdatedData[findStateIndex]["stateName"] = values[0];
      statesUpdatedData[findStateIndex]["stateCode"] = values[1];
      statesUpdatedData[findStateIndex]["desc"] = values[2];

      statesUpdatedData.sort((a, b) =>
        b.stateName.toLowerCase() < a.stateName.toLowerCase() ? 1 : -1
      );

      setManageStateInputsDialogMsg([]);
    }
  };
  const deleteState = index => {
    const findStateIndex = statesUpdatedData.findIndex(item => item.index === index);
    const updatedList = update(statesUpdatedData, {
      $splice: [[findStateIndex, 1]],
    });
    setStatesUpdatedData(updatedList);
    setManageStateInputsDialogMsg([]);
  };
  const AddState = values => {
    let maxIndex = 0;
    statesUpdatedData.map(el => {
      maxIndex = Math.max(maxIndex, el.index);
    });

    const newState = {
      index: maxIndex + 1,
      stateName: values[0],
      stateCode: values[1],
      desc: values[2],
    };

    const updatedList = update(statesUpdatedData, {
      $push: [newState],
    });
    updatedList.sort((a, b) =>
      b.stateName.toLowerCase() < a.stateName.toLowerCase() ? 1 : -1
    );
    setStatesUpdatedData(updatedList);
    setManageStateInputsDialogMsg([]);
  };

  const updateStates = async () => {
    let tenantId = null;
    if (localStorage.getItem("tenantId")) {
      tenantId = localStorage.getItem("tenantId");
    } else {
      alert("The Id of the Tenant is not defined.");
      return;
    }

    let {
      loading: loadMutation,
      error: errorMutation,
      data: dataMutation,
    } = await updateTenantStatesMutation({
      variables: {
        tenantId: parseInt(tenantId),
        updateValue: JSON.stringify(statesUpdatedData),
      },
    });
    if (!loadMutation && dataMutation.updateTenantStates.response) {
      setAlertDoneMsg({
        title: "Success",
        msg: "State records are successfully updated.",
      });
    } else {
      alert(errorMutation);
    }
  };

  const columns = [
    {
      field: "name",
      headerName: "State Name",
      minWidth: 200,
      flex: 1,
      sortable: true,
      disableColumnMenu: true,
    },
    {
      field: "code",
      headerName: "State Code",
      minWidth: 80,
      flex: 1,
      sortable: true,
      align: "center",
      headerAlign: "center",
      disableColumnMenu: true,
    },
    {
      field: "desc",
      headerName: "Description",
      minWidth: 200,
      flex: 1,
      sortable: false,
      align: "center",
      headerAlign: "center",
    },

    {
      field: "action",
      headerName: "Action",
      minWidth: 100,
      flex: 1,
      sortable: false,
      align: "center",
      headerAlign: "center",
      disableColumnMenu: true,
      renderCell: rows => {
        var editFilter = rows.row.editAccess ? "none" : "grayscale(1)";
        var editOpacity = rows.row.editAccess ? 1 : 0.5;
        var editCursor = rows.row.editAccess ? "pointer" : "auto";

        var deleteFilter = rows.row.deleteAccess ? "none" : "grayscale(1)";        
        var deleteOpacity = rows.row.deleteAccess ? 1 : 0.5;        
        var deleteCursor = rows.row.deleteAccess ? "pointer" : "auto";
        
        return (
          <Box
            pt={1}
            style={{
              display: "flex",
              flexDirection: "row",
              justifyContent: "center",
            }}
          >
            <StyledTooltip title="Edit">
              <img
                style={{
                  paddingRight: 15,
                  cursor: editCursor,
                  paddingTop: 6,
                  height: 24,
                  weight: 24,
                  filter: editFilter,
                  opacity: editOpacity,
                }}
                src={penImg}
                onClick={() =>
                rows.row.editAccess ?
                  (
                    setManageStateInputsDialogMsg({
                      title: "Edit State",
                      index: rows.row.index,
                      values: [rows.row.name, rows.row.code, rows.row.desc],
                      msg: ["Name", "Code", "Description"],
                      type: "Edit",
                    })
                  )
                  :""
                }
              />
            </StyledTooltip>
            <StyledTooltip title="Delete">
              <img
                style={{
                  paddingRight: 15,
                  cursor: deleteCursor,
                  paddingTop: 6,
                  height: 24,
                  weight: 24,
                  filter: deleteFilter,
                  opacity: deleteOpacity,
                }}
                src={trashImg}
                onClick={() =>
                  rows.row.deleteAccess ?
                  (
                    setAlertDeleteMsg({
                      title: "Delete State",
                      type: "deleteConfirmation",
                      msg: "Are you sure you want to delete state “" + rows.row.name + "”?",
                      index: rows.row.index,
                    })
                  )
                  :""
                }
              />
            </StyledTooltip>
          </Box>
        );
      },
    },
  ];

  const classes = useStyles();
  function DataGridTitle() {
    return (
      <>
        <Grid
          container
          xs={12}
          style={{
            paddingTop: 5,
            paddingBottom: 6,
            width: "100%",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <Grid item xs={2}>
            <Box
              sx={{
                p: 0.5,
                pb: 0,
              }}
            >
              <GridToolbarQuickFilter />
            </Box>
          </Grid>
          <Grid
            item
            xs={8}
            style={{
              display: "flex",
              flexDirection: "row",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <Typography variant="body1">Manage States</Typography>
            <Typography variant="h5" style={{ paddingLeft: 10, paddingTop: 3 }}>
              (Last Updated: {lastUpdate})
            </Typography>
          </Grid>
          <Grid
            item
            xs={2}
            style={{
              display: "flex",
              justifyContent: "flex-end",
              paddingRight: 10,
            }}
          >
            <Button
              variant="contained"
              size="small"
              className={classes.buttonStyle}
              disabled = {!addAccess ? "disabled" : ""}
              onClick={() =>
                addAccess ?
                (
                  setManageStateInputsDialogMsg({
                    title: "Add State",
                    msg: ["Name", "Code", "Description"],
                    type: "Add",
                  })
                )
                :""
              }
            >
              Add
            </Button>
          </Grid>
        </Grid>
        <Divider />
      </>
    );
  }

  
  if (loadContent && loadData)
    if (access)
    return (
      <div className={classes.root}>
        <Header
          breadcrumbs={[
            { label: "General Settings", link: null },
            { label: "Manage States", link: null },
          ]}
        />
        <div className={classes.container}>
          <Box mb={3} />
          <DataGrid
            className={classes.dataGridStyle}
            columns={columns}
            rows={rows}
            showCellRightBorder={true}
            // hideFooter={true}
            slots={{
              toolbar: DataGridTitle,
            }}
            slotProps={{
              toolbar: {
                showQuickFilter: true,
              },
            }}
            getRowId={row => row.index}
            autoHeight={true}
            experimentalFeatures={{ newEditingApi: true }}
            initialState={{
              pagination: { paginationModel: { pageSize: 20 } },
            }}
            pageSizeOptions={[20, 50, 100]}
          />
          <Box pt={4} pb={2}>
            <Button
              variant="contained"
              color="primary"
              className={classes.buttonStyle}
              style={{ marginRight: 2, width: "150px" }}
              onClick={updateStates}
            >
              Update States
            </Button>

            <Button
              variant="text"
              color="primary"
              className={classes.outlinedButtonStyle}
              onClick={() => navigate(`${project_url}/tenant/dashboard`)}
            >
              Cancel
            </Button>
          </Box>
          {alertDeleteMsg.msg && (
            <AlertDialog
              title={alertDeleteMsg.title}
              type={alertDeleteMsg.type}
              contentMsg={alertDeleteMsg.msg}
              closeDialog={() => setAlertDeleteMsg([])}
              deleteAction={() => {
                setAlertDeleteMsg([]);
                deleteState(alertDeleteMsg.index);
              }}
            />
          )}
          {manageStateInputsDialogMsg.msg && (
            <ManageStateInputsDialog
              title={manageStateInputsDialogMsg.title}
              text={manageStateInputsDialogMsg.text}
              values={manageStateInputsDialogMsg.values}
              data={statesUpdatedData}
              contentMsg={manageStateInputsDialogMsg.msg}
              closeDialog={() => setManageStateInputsDialogMsg([])}
              addEditDialog={values => {
                if (manageStateInputsDialogMsg.type === "Edit")
                  updateState(values, manageStateInputsDialogMsg.index);
                if (manageStateInputsDialogMsg.type === "Add") AddState(values);
              }}
            />
          )}
          {alertDoneMsg.msg && (
            <AlertDialog
              title={alertDoneMsg.title}
              contentMsg={alertDoneMsg.msg}
              closeDialog={() => navigate(`${project_url}/tenant/dashboard`)}
            />
          )}
        </div>
      </div>
    );
  
  else 
      return (
        <div className={classes.root}>          
          <div className={classes.container}>
            <AlertDialog
                title="No Permission"
                contentMsg='You do not have permission to access this page.
                            Click the "Done" button and navigate the system through the designated menu options on the sidebar menu.' 
                closeDialog={() => {
                  navigate(`${project_url}/tenant/dashboard`);
                }}
              />
            
          </div>
        </div>
      );
  else return;
}

export default ManageStates;
